import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { IGreetingsDTO } from '../../dto/greetings/greetings.dto';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-greetings',
  imports: [NzTypographyComponent, NzRowDirective, NzColDirective],
  templateUrl: './greetings.component.html',
  styleUrl: './greetings.component.less',
})
export class GreetingsComponent {
  public readonly greetingsDTO: InputSignal<IGreetingsDTO> =
    input.required<IGreetingsDTO>();
}
